var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-dropzone',{ref:(_vm.type + "-upload"),attrs:{"id":(_vm.type + "-upload"),"options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.uploadComplete,"vdropzone-error":_vm.uploadError}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }